import BlockDivider from './widget-props/block-divider'
import BlockTitle from './widget-props/block-title'
import ColorSelector from './widget-props/color-selector'
import PropsWrapper from './widget-props/DvPropsWrapper'
import SelectDatasource from './widget-props/select-datasource'
import SelectDatasourceType from './widget-props/select-datasource-type'

function install (Vue) {
  if (install.installed) return
  install.installed = true
  console.log("-----注册了大屏组件----");
  Vue.component('BlockDivider', BlockDivider);
  Vue.component('BlockTitle', BlockTitle);
  Vue.component('ColorSelector', ColorSelector);
  Vue.component('PropsWrapper', PropsWrapper);
  Vue.component('SelectDatasource', SelectDatasource);
  Vue.component('SelectDatasourceType', SelectDatasourceType);
}

export default install
